<template>
  <v-textarea
    v-model="model"
    :label="label"
    :placeholder="placeholder"
    :rows="rows"
    :row-height="rowHeight"
    :variant="variant"
    :density="density"
    :error="error"
    :error-messages="errorMessages"
    auto-grow
    @update:model-value="handleUpdate"
  />
</template>

<script>
export default {
  name: "RbTextarea",

  props: {
    modelValue: [String, Number],

    label: String,

    placeholder: String,

    rows: {
      type: [String, Number],
      default: 4,
    },

    rowHeight: {
      type: [String, Number],
      default: 15,
    },

    variant: {
      type: String,
      default: "outlined",
    },

    density: {
      type: String,
      default: "compact",
    },

    error: Boolean,

    errorMessages: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["update:modelValue", "change"],

  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  methods: {
    handleUpdate(value) {
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style scoped>
::v-deep(.v-field__input) {
  font-size: 13px;
}
::v-deep(.v-label) {
  font-size: 12px;
}
::v-deep(.v-field-label) {
  font-size: 11px;
}
</style>